import { validateCredit } from "./helpers";

export const extraSettings = items => {
	return {
		enableAutocomplete: true,
		dataSource: "Static",
		items: items,
		storage: "Id",
		identity: "id",
		multi: false
	};
};

export const getNumberConfig = (label, path, index, field, item, enabled, isFieldRequired) => {
	const value = item[field] ?? null;

	return {
		label: label,
		$path: `${path}.${index}.${field}`,
		$errors: validateCredit(value, isFieldRequired),
		type: "number",
		value: value,
		enabled: enabled,
		extraSettings: {
			min: 0,
			max: 100
		}
	};
};

export const getEffortConfig = ({ label, path, index, effortField, effortType, effortFormat, effortMonthsValue, enabled }) => {
	const maxValue = effortFormat === "percentage" ? 100 : effortMonthsValue;

	return {
		label: label,
		$path: `${path}.${index}.${effortField}.${effortType}`,
		type: "number",
		enabled,
		extraSettings: {
			min: 0,
			max: maxValue,
			fractionSize: 2,
			effortMonthsValue,
			numberFormat: ",.",
		},
		invalidFractionErrorMessage: "Must have 0-2 decimal places",
	};
};

export const getSelectConfig = (label, path, index, field, items, rest = {}) => ({
	label: label,
	$path: `${path}.${index}.${field}`,
	type: "select",
	enabled: rest.enabled,
	extraSettings: extraSettings(items),
	...rest,
});

export const getEffortConfigs = ({ index, path, fieldFormat, effortFormat, lookup, isEnabled }) => ({
	sponsoredNumber: {
		calendar: getEffortConfig({
			label: "",
			path: `${path}.0`,
			index,
			effortField: `sponsoredEffort${fieldFormat}`,
			effortType: "calendar",
			effortFormat,
			effortMonthsValue: lookup.calendarMonths,
			enabled: !!isEnabled && !!lookup.isCalendarAppointment,
		}),
		academic: getEffortConfig({
			label: "",
			path: `${path}.0`,
			index,
			effortField: `sponsoredEffort${fieldFormat}`,
			effortType: "academic",
			effortFormat,
			effortMonthsValue: lookup.academicMonths,
			enabled: !!isEnabled && !!lookup.isAcademicAppointment,
		}),
		summer: getEffortConfig({
			label: "",
			path: `${path}.0`,
			index,
			effortField: `sponsoredEffort${fieldFormat}`,
			effortType: "summer",
			effortFormat,
			effortMonthsValue: lookup.summerMonths,
			enabled: !!isEnabled && !!lookup.isSummerAppointment,
		}),
	},
	costShare: {
		calendar: getEffortConfig({
			label: "",
			path: `${path}.0`,
			index,
			effortField: `costShareEffort${fieldFormat}`,
			effortType: "calendar",
			effortFormat,
			effortMonthsValue: lookup.calendarMonths,
			enabled: !!isEnabled && !!lookup.isCalendarAppointment,
		}),
		academic: getEffortConfig({
			label: "",
			path: `${path}.0`,
			index,
			effortField: `costShareEffort${fieldFormat}`,
			effortType: "academic",
			effortFormat,
			effortMonthsValue: lookup.academicMonths,
			enabled: !!isEnabled && !!lookup.isAcademicAppointment,
		}),
		summer: getEffortConfig({
			label: "",
			path: `${path}.0`,
			index,
			effortField: `costShareEffort${fieldFormat}`,
			effortType: "summer",
			effortFormat,
			effortMonthsValue: lookup.summerMonths,
			enabled: !!isEnabled && !!lookup.isSummerAppointment,
		}),
	}
});
